export enum EProfileUrl {
  PROFILE = 'profile',
  PHOTO = 'photo',
  NAME = 'name',
}
